import Vue from 'vue';
import { getPost } from './request';
import { BFD_checkApp } from './bfdApp';
import { checkXcx } from '@/utils/checkXcx.js';
import { getCatchAddress } from 'dflocationsdk';

import { getTags } from '../assets/js/api';
import { fetchTagsList, dealTagsList } from '../tags';
import * as constant from '@/utils/constant';

import { TLang } from './lang';
import { hotelFilter } from './hotelFilter';
import { lexiangFilter } from './lexiangFilter';
import { filter } from 'lodash';
import config from '../tab.conf';
import { publicFunc } from "@/utils/func.js";
import { insertHotGoods, insertHotGoodsByPageIndex } from "./recommendgood";
import Cookies from 'js-cookie';
export const isServer = Vue.prototype.$isServer;

/**
 * 判断是否是安卓
 */
export function isAndroid() {
  return isServer ? false : /android/.test(navigator.userAgent.toLowerCase());
}

/**
 * 判断是否是IOS
 */
export function isIOS() {
  return isServer ? false : /ios|iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase());
}

/**
 * iosMobile
 */
export function iosMobile() {
  const u = navigator.userAgent;
  return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) && !!u.match(/AppleWebKit.*Mobile.*/);
}

/**
 * iosMobile
 */
export function AndroidMobile() {
  const u = navigator.userAgent;
  return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
}

/**
 * 判断h5系统
 */
export function h5Platform() {
  let num = 0;
  const isBFDAPP = BFD_checkApp();
  if (!isBFDAPP) {
    if (AndroidMobile()) {
      num = 1;
    }
    if (iosMobile()) {
      num = 2;
    }
  } else {
    if (AndroidMobile()) {
      num = 3;
    }
    if (iosMobile()) {
      num = 4;
    }
  }
  return num;
}

/**
 * 返回一个范围
 * @param  {Number} num
 * @param  {Number} min
 * @param  {Number} max
 * @return {Number}
 */
export function range(num, min, max) {
  return Math.min(Math.max(num, min), max);
}

/**
 *
 * @param  {String} name 参数名字
 * @return {String}
 */
export function getQueryString(name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  const res = window.location.search.substr(1).match(reg);
  if (res !== null) return window.decodeURIComponent(res[2]);
  return '';
}

/**
 * 判断工会头
 */
export function unionFlag() {
  let currentUnionValue;
  const union = getQueryString('union');
  const { VUE_APP_FLAG } = process.env;
  const { hostname, pathname } = window.location;

  if (union) {
    // URI带union参数的判断是工会链接
    return union;
  } else if (/^corp/.test(pathname) && pathname.match(/union\/\w+/g)) {
    // 测试环境http://corp.m.test03.com/union/lifangfang02/user/login
    currentUnionValue = pathname.match(/union\/\w+/g)[0].split('/')[1];
  } else {
    // 正式环境http://www.dbenefit.dongfangfuli.com/bfd_pc/index?union=dbenefit&city=2
    // 测试环境http://union.testzhou.zhouweiwei.qa.psf-dev.com/
    // k8s测试环境http://www.lifangfang02.test01.com/drama_pc/home?city=145&mc=Shows
    // stage环境http://www.rjh.stage.dongfangfuli.com/shop/home?city=145&mc=Shopping
    if ((VUE_APP_FLAG === 'test' && /^(?:union)/.test(hostname)) || /^(?:w{3})\.((?!stage)[A-Za-z1-9]{1}(\w|-)+\.)(stage\.)?(\w+\.)(?=com)/.test(hostname)) {
      currentUnionValue = hostname.split('.')[1];
    } else {
      currentUnionValue = '';
    }

    return currentUnionValue;
  }
}

/**
 * 获取cookie
 * @param {String} sKey 获取cookie对应的名字
 * @return {String | Object}
 */
export function getCookie(sKey) {
  return decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || null;
}

/**
 * 时间戳转换成年月日
 * @param inputTime  时间戳
 * @returns yyyy-MM-dd HH:mm:ss
 */
export function formatDateTime(inputTime) {
  var date = new Date(inputTime);
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? '0' + m : m;
  var d = date.getDate();
  d = d < 10 ? '0' + d : d;
  var h = date.getHours();
  h = h < 10 ? '0' + h : h;
  var minute = date.getMinutes();
  var second = date.getSeconds();
  minute = minute < 10 ? '0' + minute : minute;
  second = second < 10 ? '0' + second : second;
  return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
}

// 乐福小程序埋点
export function getXcxGioName(code) {
  switch (code) {
    case 'lfmini':
      return 'h5-东福乐福小程序';
    // case 'bfdmini':
    // case 'gwmini':
    // case 'exchangemini':
    default:
      return 'h5-微信小程序';
  }
}

/**
 * gio埋点
 * @param { String } eventName // 事件名称
 * @param { Object } params // 参数
 * @param { boolean } cache // 是否走缓存公共方法
 */
export function gioClickHandle(eventName, params, cache) {
  // console.log('eventName', eventName, JSON.stringify(params));
  try {
    const now = formatDateTime(new Date());
    const newParams = getGioParams(eventName, params);
    console.log('eventName', eventName, JSON.stringify(newParams));
    if (cache) {
      // 调用公共方法
      try {
        window.setGioExposureData(newParams);
      } catch (error) {
        console.error(error);
      }
    } else {
      gio('track', eventName, newParams);
      const url = `https://api.growingio.com/v3/80a245b29a70c4ad/s2s/cstm?stm=${now}`;

      const postParams = [
        {
          cs1: getCookie('gr_user_id') || 'wjn',
          tm: now,
          t: 'cstm',
          n: eventName,
          var: params,
        },
      ];
    }
    // console.log("gio", newParams)
    // debugger
    // getPost( url, postParams);
  } catch (error) {
    console.log(error);
  }
}

export function getExchangePlatformCode() {
  let origin = window.location.origin
  if (origin.indexOf('m-zx') > -1) {
    return '甄选'
  } else if (origin.indexOf('exchange') > -1) {
    return '产品册'
  } else if (origin.indexOf('corp') > -1) {
    return '百福得'
  } else {
    return '官网'
  }
}

export function getGioParams(eventName, params = {}) {
  try {
    const nowTime = formatDateTime(new Date());
    let cityId = '';
    const address = getCookieAddressInfo() || JSON.parse(getCookie('address') || null);
    if (!address || !address.cityId) {
      let cid = getQueryString('city') || '';
      cityId = cid;
    } else {
      cityId = address.cityId;
    }
    // const uid = getCookie('unionUserId') || getCookie('mall_userId') || '';
    const uid = Cookies.get('h5_userInfo_userId')
    const url = window.parent.location.href;
    const unionCode = unionFlag();
    let source = unionCode && !checkUnifyShop() ? "百福得" : "官网";
    const _window = window;
    let platformInfo = 'h5';
    const lfFlag = getCookie('df_channel_source')
    if (BFD_checkApp()) {
      if (iosMobile()) {
        platformInfo = 'h5-IOS';
      }
      if (AndroidMobile()) {
        platformInfo = 'h5-Android';
      }
    // } else if (_window && _window.DF_getCurrentField()) {
    //   platformInfo = getXcxGioName(_window.DF_getCurrentField());
    } else if (checkXcx()) {
      // platformInfo = "微信小程序";
      if (lfFlag && lfFlag == "lf") {
        platformInfo = "h5-乐福小程序"
      } else {
        platformInfo = "h5-微信小程序"
      }
    }

    let paramCommon = {
      df_platform: platformInfo, // 平台  微信小程序、PC、H5、Android、iOS
      df_source: source, // 渠道  百福得/exchange/官网
      df_prepagename: url ? url : null, // 前置页面
      df_pagename: '搜索结果页', // 页面名称
      df_cityid: cityId, // 城市ID
      df_activitytime: nowTime, //事件时间
      df_channle: '', // 频道   福利商城首页/节日礼包/电影/演出/旅游玩乐/健康生活/生日汇/优选生活/企业活动/图书/京东优选
      df_modulename: '', // 模块名称  搜索关键词/搜索结果商品
      df_elementname: '', //元素名  搜索关键词/搜索结果商品点击/搜索结果商品加购
      df_userid: uid || '', // 用户ID
      // open_id: '',  //用户在微信小程序/公众号的唯一标识，小程序特有
      // df_unionid:'', // 用户在微信的唯一标识，小程序特有
      df_versionNum: '', //版本号 微信小程序上线版本号
      df_deviceid: window.df_deviceid,
      // df_label: '', // 用户标签  黑名单、大客户、黄牛
      df_ExchangePlatform: getExchangePlatformCode(),  // 兑换平台
    };
    switch (eventName) {
      case 'DF_elementClick':
        paramCommon.df_searchKeyword = ''; // 搜索关键词
        paramCommon.df_ifSearchResult = ''; //是否有搜索结果 有/无
        paramCommon.df_ifLogin = ''; // 是否登录
        paramCommon.df_resultPage = ''; // 商品所在页码
        paramCommon.df_goodsname = ''; // 商品名称
        paramCommon.df_goodsChannel = ''; // 商品频道 节日礼包/电影/演出/旅游玩乐/健康生活/生日汇/优选生活/图书/京东优选
        paramCommon.df_firstCategory = ''; //一级类目  酒水饮料器皿
        paramCommon.df_secondCategory = ''; // 二级类目  果汁/饮料
        paramCommon.df_brand = ''; // 商品品牌  星巴克
        paramCommon.df_firstCategoryId = ''; // 一级类目Id
        break;
    }
    
    let fromType = getQueryString('fromType');
    if (fromType == 'sort') {
      paramCommon.searchType =  '分类页为你推荐商品集'; // 一级类目Id
    }

    let paramNew = Object.assign(paramCommon, params);
    return paramNew;
  } catch (error) {}
  return {};
}

/**
 * 将文字中金额进行膨胀(百福得)
 * @param String
 * return String
 */
export function replacePrice(reStr, scale) {
  var text = String(reStr);
  var newStr = text.replace(/(\d[\d\.]*)/g, function (x) {
    var n = Number(x);
    if (x == n) {
      return parseFloat(x * (scale ? scale : 1).toFixed(2));
    }
  });
  return newStr;
}

// 浏览器定位
export function initBrowseLoaction(callBack) {
  console.log('initBrowseLoaction-callBack', window.navigator.geolocation);
  window.navigator.geolocation.getCurrentPosition(
    (position) => {
      console.log('location1', position);
      const location = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
      console.log('location', location);
      callBack(location);
    },
    (err) => {
      console.log('initBrowseLoaction-err', err);
      callBack(null);
    },
    {
      timeout: 5000, // 5 秒超时
    },
  );
}

/**
 * 获取用户定位信息
 * @param {*} mapKey 腾讯地图key
 */
export function getUserLoactionNow(mapKey = 'OE2BZ-6FWRQ-LFQ56-GOGXT-CKES2-OEBS2') {
  return new Promise(function (resolve, reject) {
    window.jsonCallBack = (result) => {
      resolve(result);
    };
    var JSONP = document.createElement('script');
    JSONP.type = 'text/javascript';
    JSONP.src = `https://apis.map.qq.com/ws/location/v1/ip?key=${mapKey}&output=jsonp&callback=jsonCallBack`;
    JSONP.onerror = reject;
    document.getElementsByTagName('head')[0].appendChild(JSONP);
    setTimeout(() => {
      document.getElementsByTagName('head')[0].removeChild(JSONP);
    }, 500);
  });
}

/// 微信定位
function initWXLoaction(callBack) {
  try {
    if (typeof window.entryUrl === 'undefined' || window.entryUrl === '') {
      window.entryUrl = location.href.split('#')[0];
    }
    let signLink = /(Android)/i.test(navigator.userAgent) ? location.href.split('#')[0] : window.entryUrl;
    const type = navigator.userAgent.match(/wxwork/i) ? 2 : 1;
    // const params = { caller: type, url: window.location.href.split('#')[0] }
    const params = { caller: type, url: signLink };
    const _window = window;
    let host = window.location.hostname;
    const linkUrl = '//' + host + '/gw/app/permission_valid_config/signature';
    // console.log('微信权限入参', linkUrl, params)
    getPost(linkUrl, params, false).then((e) => {
      // console.log('dddddd', e)
      if (e.data.code === 222640) {
        // getUserLoactionNow().then((data) => {
        //   if (data.status === 0 && data.result && data.result.location) {
        //     localStorage.setItem("systemLoaction", JSON.stringify(data.result.location));
        //   } else {
        //     callBack && callBack(null)
        //   }
        // });
        callBack && callBack(null);
        return;
      }
      console.log('e.data.body', e.data.body);
      _window.wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: e.data.body.appId, // 必填，公众号的唯一标识
        timestamp: e.data.body.timestamp, // 必填，生成签名的时间戳
        nonceStr: e.data.body.nonceStr, // 必填，生成签名的随机串
        signature: e.data.body.signature, // 必填，签名
        jsApiList: ['getLocation'], // 必填，需要使用的JS接口列表
      });
      _window.wx.ready(function () {
        _window.wx.getLocation({
          type: 'wgs84',
          success(res) {
            const location = {
              lat: res.latitude,
              lng: res.longitude,
            };
            console.log('success', res);
            callBack && callBack(location);
          },
          fail(res) {
            console.log('微信授权失败', res);
            callBack && callBack(null);
          },
        });
      });
    });
  } catch (ex) {
    console.log('微信鉴权失败', res);
    callBack && callBack(null);
  }
}

// 获取定位
export const getUserLoaction = (callBack) =>
  new Promise(function (resolve, reject) {
    let ua = navigator.userAgent.toLowerCase();
    console.log(ua);
    let v = ua.match(/MicroMessenger/i);
    try {
      if (v && v.length > 0 && v[0] === 'micromessenger') {
        console.log('initWXLoaction');
        initWXLoaction(resolve);
      } else if (window.navigator.geolocation) {
        console.log('initBrowseLoaction');
        initBrowseLoaction(resolve);
      }
    } catch (ex) {
      console.log('catch', ex);
      reject(null);
    }
  });

/**
 * 判断来自哪个频道（暂时只针对体检、旅游、玩乐、演出）
 * http://confluence.psf-dev.com/pages/viewpage.action?pageId=47883653
 */
export function checkFromChannel() {
  let from = null;

  if (localStorage.getItem('RETURN_URL')) {
    const URL = localStorage.getItem('RETURN_URL');

    // 旅游玩乐首页
    if (URL.indexOf('scenery/list') > -1 || URL.indexOf('activity/list') > -1) {
      from = ['景点', '玩乐'];
    } else if (URL.indexOf('drama_h5') > -1) {
      from = ['演出'];
    } else if (URL.indexOf('health') > -1) {
      from = ['体检套餐', '体检机构', '口腔健康', '健康商城'];
    }
  }

  return from;
}

// 字符串url参数截取
export function getLinkQueryString(str, name) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
  const r = str.split('?')[1].match(reg);
  if (r != null) {
    undefined;
    return decodeURIComponent(r[2]);
  }
  return null;
}

/**
 * 加载钉钉依赖文件
 */
export function loadDINGDING() {
  const ua = navigator.userAgent.toLowerCase();
  let b = false;
  if (ua.match(/DingTalk/i) == 'dingtalk') {
    // 用钉钉打开
    // console.log('123')
    b = true;
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = '//g.alicdn.com/dingding/dingtalk-jsapi/2.13.42/dingtalk.open.js';
    document.head.appendChild(script);
    console.log('loadDINGDING');
  }
  return b;
}

/**
 * 获取综合筛选条件 session
 */
const perfix = 'SEARCH_';
/**
 * 设置综合筛选条件 session
 */
export function setBusTagFronSession(value) {
  // const searchData = JSON.parse(sessionStorage.getItem(`searchData`) || '{}')
  // debugger
  // sessionStorage.setItem(`searchData`, JSON.stringify({
  //   ...searchData,
  //   busTagctiveKey: value
  // }))
  return value;
}

/**
 * 首字母大写
 */
export function capitalized(name) {
  const capitalizedFirst = name[0].toUpperCase();
  const rest = name.slice(1);
  return capitalizedFirst + rest;
}

/**
 * 获取筛选有效字段
 */

export function getFilterParam(payload) {
  if (!payload) {
    return {};
  }
  let filters = {};
  // 搜索页面品牌筛选
  if (payload.brand) {
    filters.brand = payload.brand;
  }

  // 搜索页面品牌筛选
  if (payload.regions && payload.regions.length > 0) {
    filters.regions = payload.regions;
  }

  // 搜索页面品牌筛选
  if (payload.region) {
    filters.region = payload.region;
  }

  // 搜索页面分类
  if (payload.categoryIds && payload.categoryIds.length > 0) {
    filters.categoryIds = payload.categoryIds;
  }
  // 搜索页面分类完整数组
  if (payload.categoryList && payload.categoryList.length > 0) {
    filters.categoryList = payload.categoryList;
  }
  // 搜索页频道
  if (payload.productTypes && payload.productTypes.length > 0) {
    if(payload.productTypes == '线下商户'){
      filters.priceSortType = '美食汇';
    } else {
      filters.productTypes = payload.productTypes;
    }
    
  } else {
    const path = window.location.pathname;
    const typeObj = config.find((item) => path.includes(item.path));
    if (typeObj) {
      filters.productTypes = typeObj.name;
    } else {
      // 兼容返回数据缓存情况
    if (getQueryString('productTypes')) {
      if (getQueryString('productTypes') == '线下商户'){
        filters.productTypes = '美食汇';
      } else {
        filters.productTypes = getQueryString('productTypes');
      }
    } else {
      filters.productTypes = '全部';
    }
      
    }
    
  }
  //是否仅看有货
  // filters.containsNoStock = payload.containsNoStock;

  //排序
  if (payload.sortField) {
    filters.sortField = payload.sortField;
  }

  // 排序名称
  if (payload.sortFieldName) {
    filters.sortFieldName = payload.sortFieldName;
  }

  // 最大值
  if (payload.maxPrice) {
    filters.maxPrice = payload.maxPrice;
  }
  // 最小值
  if (payload.minPrice) {
    filters.minPrice = payload.minPrice;
  }

  // 距离
  if (payload.distance) {
    filters.distance = payload.distance;
  }

  // 距离名称
  if (payload.distanceName) {
    filters.distanceName = payload.distanceName;
  }

  // 综合
  if (payload.sortType) {
    filters.sortType = payload.sortType;
  }
  // 前台标签筛选
  if (payload.businessFrontTagId) {
    filters.businessFrontTagId = payload.businessFrontTagId;
  }
  // 前台标签名称
  if (payload.businessFrontTagName) {
    filters.businessFrontTagName = payload.businessFrontTagName;
  }

  // 目的地
  if (payload.destinations && payload.destinations.length > 0) {
    filters.destinations = payload.destinations;
  }
  // 出发地
  if (payload.departures && payload.departures.length > 0) {
    filters.departures = payload.departures;
  }
  // 主题
  if (payload.topics && payload.topics.length > 0) {
    filters.topics = payload.topics;
  }
  // 时间
  if (payload.time) {
    filters.time = payload.time;
  }
  // 时间名称
  if (payload.timeName) {
    filters.timeName = payload.timeName;
  }
  // 价格排序
  if (payload.priceSortType) {
    filters.priceSortType = payload.priceSortType;
  }

  // // 价格排序名称
  // if (payload.priceSortName){
  //   filters.priceSortName = payload.priceSortName;
  // }

  // 医院
  if (payload.institutionLevels && payload.institutionLevels.length > 0) {
    filters.institutionLevels = payload.institutionLevels;
  }

  // 性别
  if (payload.tags && payload.tags.length > 0) {
    filters.tags = payload.tags;
  }

  // 区域
  if (payload.regionId) {
    filters.regionId = payload.regionId;
  }

  return filters;
}

/**
 * 实体新Tab
 */
export function addTab(data) {
  let arr = [];
  if (data) {
    for (var key in data) {
      arr.push({
        name: `${data[key]}`,
        path: `${key}`,
      });
    }
  }
  return arr;
}

function addCSContainerHeight(payload, searchListResponseDto) {
  const { pageIndex, pageSize } = payload;
  const { totalCount } = searchListResponseDto;
  if (pageIndex * pageSize < totalCount) {
    return;
  }
  // 滑动列表增加下边距
  const csContainer = document.querySelector('.cs');
  if (csContainer) {
    csContainer.classList.add('cs-shopCat');
  }
  // 防止购物车遮挡商品
  const appContainer = document.querySelector('#app');
  const { pathname } = window.location;
  const lastIndex = pathname.lastIndexOf('/');
  const path = pathname.substring(lastIndex + 1);
  if (appContainer && showShoppingCart(path)) {
    appContainer.classList.add('app-shopCar');
  }
}

/**
 * 组装接口返回数据
 */
export function getResultObj(commit, payload, resolve, reject, searchListResponseDto, businessFrontTags = [], isFromCategory, state) {
  // debugger
  addCSContainerHeight(payload, searchListResponseDto) 
  commit('setSearchKey', payload.key);
  const { pathname } = window.location;
  const { pageIndex, onlyGetOrg } = payload;
  const lastIndex = pathname.lastIndexOf('/');
  const name = pathname.substr(lastIndex + 1);

  const { businessFrontTagId } = payload || {};
  const busTagParams = {
    businessFrontTagId,
    businessFrontTags,
  };

  commit('setLoadErrorState', {
    name: name,
    value: false,
  });
  commit('setNoStockGrayStatus', {
    noStockGrayStatus: searchListResponseDto ? searchListResponseDto.noStockGrayStatus : false,
  });

  // commit("setBusinessFrontTags", {
  //   businessFrontTags: businessFrontTags || []
  // })

  if (searchListResponseDto && searchListResponseDto.cardInfos) {
    commit('setCardsInfo', {
      cardInfos: searchListResponseDto.cardInfos ? searchListResponseDto.cardInfos : [],
    });
  }
  if (searchListResponseDto && searchListResponseDto.suggestWords) {
    commit('setSuggestWords', {
      cardInfos: searchListResponseDto.suggestWords ? searchListResponseDto.suggestWords : [],
    });
  }

  if (payload.isSearchAction && businessFrontTags) {
    const gioParams = {
      df_searchKeyword: payload.key || '',
      df_modulename: '标签筛选',
      df_elementname: '运营标签',
      df_contentTitle: businessFrontTags.map((bus) => bus.businessFrontTagName).join('，'),
    };
    gioClickHandle('DF_exposureEvent', gioParams);
  }
  // 筛选分类，结果返回触发埋点
  // if (isFromCategory) {
  let pathName = window.location.pathname;
  let channelName = '全部';
  if (pathName.indexOf('home') > -1) {
    channelName = '全部';
  } else if (getQueryString('productTypes')) {
    channelName = getQueryString('productTypes');
  }
  gioClickHandle('DF_elementClick', {
    df_searchKeyword: payload.key,
    df_ifSearchResult: searchListResponseDto && searchListResponseDto.searches && searchListResponseDto.searches.length > 0 ? '有' : '无',
    df_ifLogin: state.loginInfo.loginFlag ? '是' : '否',
    df_cityid: state.loginInfo.city,
    df_modulename: '搜索关键词',
    df_elementname: isFromCategory || '搜索关键词',
    df_channle: channelName,
    df_filter: getFilterParam(state.allQuery),
  });
  // }
  if (searchListResponseDto && searchListResponseDto.searches && searchListResponseDto.searches.length > 0) {
    let { category, products, searches, totalCount, isGuide } = searchListResponseDto;
    const totalNumber = Math.ceil(totalCount / 10);
    let ids = [];
    searches.map((item) => {
      if (item.categoryId && item.id) {
        ids.push({
          goodsId: item.id,
          categoryId: item.categoryId,
        });
      } else if ([3, 64, 32].includes(item.channel)) {
        ids.push({
          goodsId: item.id,
          channelId: item.channel,
        });
      }
      // 处理体检套餐商品， categoryId与高明朋约定传0
      if (item.id && item.productType == '体检套餐') {
        ids.push({
          goodsId: item.id,
          categoryId: 0,
        });
      }
    });
    // aaaaaaaaaaaaaa
    const _categorys = getSearchWhere(products, category, searchListResponseDto, state);
    changeStoreData(commit, state, onlyGetOrg, searches, totalCount, isGuide, busTagParams, pageIndex, name, totalNumber, _categorys);
    getSearchTags(ids, searches, payload.productTypes, commit, state, onlyGetOrg, totalCount, isGuide, busTagParams, pageIndex, name, totalNumber, _categorys);
    resolve(searchListResponseDto);
  } else {
    if (!onlyGetOrg) {
      if (searchListResponseDto && searchListResponseDto.recommondList && searchListResponseDto.recommondList.length > 0) {
        let recommendList = searchListResponseDto.recommondList;
        let ids = [];
        recommendList.forEach((item) => {
          if (item.categoryId && item.id) {
            ids.push({
              goodsId: item.id,
              categoryId: item.categoryId,
            });
          } else if ([3, 64, 32].includes(item.channel)) {
            ids.push({
              goodsId: item.id,
              channelId: item.channel,
            });
          }
        });
        getTags(ids).then((res) => {
          if (res && res.data && res.data.body) {
            res.data.body.map((item) => {
              let good = {};
              good.promoStickerInfo = [];
              good.hasPromoSticker = false;
              good.hasPromoTags = false;
              good.promoTags = [];
              const index = recommendList.findIndex((t) => t.id === item.goodsId && t.categoryId === item.categoryId);
              if (item.tags && item.tags.length > 0) {
                const tags = item && item.tags ? item.tags : [];
                tags &&
                  tags.length > 0 &&
                  tags.map((info, i) => {
                    // type 1、促销 2、爆炸贴 3、新品
                    // mktFrontType 9003、限购 9004、起购 9005频道标签 9006运营标签 90061导购标签 90062推荐标签 9007 体检自营标签 300001抽奖
                    if (info.type === 2) {
                      good.promoStickerInfo.push(info);
                      good.hasPromoSticker = true;
                    } else if (
                      info.type === 1 ||
                      info.type === 3 ||
                      info.mktFrontType === 400001 ||
                      info.mktFrontType === 9003 ||
                      info.mktFrontType === 9004 ||
                      info.mktFrontType === 9005 ||
                      info.mktFrontType === 9006 ||
                      info.mktFrontType === 90061 ||
                      info.mktFrontType === 90062 ||
                      info.mktFrontType === 9007 ||
                      info.mktFrontType === 300001
                    ) {
                      good.hasPromoTags = true;
                      good.promoTags.push(info);
                    }
                  });
                if (index > -1) {
                  recommendList[index].tags = item;
                  recommendList[index].promoStickerInfo = good.promoStickerInfo;
                  recommendList[index].hasPromoSticker = good.hasPromoSticker;
                  recommendList[index].hasPromoTags = good.hasPromoTags;
                  recommendList[index].promoTags = good.promoTags;

                  // 折上折
                  recommendList[index].mktTagShow = item.mktTagShow;
                  recommendList[index].discountTagShow = item.discountTagShow;
                  recommendList[index].discountPrice = item.discountPrice;
                  recommendList[index].discount = item.discountEnText;
                  recommendList[index].totalLimit = item.totalLimit;
                  recommendList[index].saleNum = item.saleNum || 0;
                  recommendList[index].dfPriceVo = item.dfPriceVo || null;
                }
              }
              if (index > -1) {
                recommendList[index].tags = item && item;
                recommendList[index].bizStock = item.bizStock;
                // 折上折
                recommendList[index].mktTagShow = item.mktTagShow;
                recommendList[index].discountTagShow = item.discountTagShow;
                recommendList[index].discountPrice = item.discountPrice;
                recommendList[index].discount = item.discountEnText;
                recommendList[index].totalLimit = item.totalLimit;
                recommendList[index].saleNum = item.saleNum || 0;
                recommendList[index].dfPriceVo = item.dfPriceVo || null;
              }
            });
            commit('updateData', {
              searches: [],
              name,
              pageIndex,
              totalNumber: 1,
              value: true,
              totalCount: 0,
              recommendList: recommendList,
              isGuide: 1,
            });
          } else {
            commit('updateData', {
              searches: [],
              name,
              pageIndex,
              totalNumber: 1,
              value: true,
              totalCount: 0,
              recommendList: recommendList || [],
              isGuide: 1,
            });
          }
        });
      } else {
        commit('updateData', {
          searches: [],
          name,
          pageIndex,
          totalNumber: 1,
          value: true,
          totalCount: 0,
          recommendList: [],
          isGuide: 1,
        });
      }
    } else {
      commit('updateData', {
        topOrgList: [],
        orgTotal: 0,
        isAllOrgData: false,
        name,
        onlyGetOrg,
      });
    }
    window.sessionStorage.setItem('searchData', '');
    resolve(searchListResponseDto);
  }
}

export function getSearchWhere(products, category, searchListResponseDto, state) {
  let arr = [];
  if (products && products.length) {
    products.map((pro) => {
      if (pro.defaultFlag) {
        // 蛋糕,电子券删除分类,增加排序, 优选生活增加排序
        if (
          pro.productType === "电子券" ||
          pro.productType === "蛋糕" ||
          pro.productType === "优选生活" ||
          pro.productType === "小米有品" ||
          pro.productType === "节日礼包" ||
          pro.productType === "图书" ||
          pro.productType === "京东优选" ||
          pro.productType === "健康商城" ||
          pro.productType === "网易严选" ||
          constant.newEntityType.includes(pro.productType) ||
          pro.productType === '东福超市'
        ) {
          if (pro.productType === '电子券' || pro.productType === '蛋糕') {
            const index = category.findIndex((item) => item.name === '分类');
            index > -1 && category.splice(index, 1);
          } else {
            category.reverse();
          }

          const priceCategory = {
            name: '价格',
            sort: true,
            list: [
              {
                id: 0,
                name: 'asc',
              },
              {
                id: 1,
                name: 'desc',
              },
            ],
          };
          const sortCategory = {
            name: '排序',
            list: [
              {
                id: 1,
                name: '综合推荐',
                shotName: '综合',
              },
              {
                id: 2,
                name: '销量由高到低',
                shotName: '销量',
              },
              {
                id: 3,
                name: "新品优先",
                shotName: "新品",
              },
              {
                id: 5,
                name: '热度优先',
                shotName: '热度',
              },
            ],
          };
          // if (pro.productType != "电子券") {
            sortCategory.list.push(
              {
                id: 'price-asc',
                name: '价格升序',
                shotName: '价格升序',
                type: 'asc',
              },
              {
                id: 'price-desc',
                name: '价格降序',
                shotName: '价格降序',
                type: 'desc',
              },
            );
          // }
          category.unshift(sortCategory);
          // if (pro.productType === "电子券") {
          //   category.push(priceCategory);
          // }

          return category;
        }
        if (pro.productType === '听书') {
          category.unshift({
            name: '排序',
            list: [
              {
                id: 1,
                name: '综合排序',
                shotName: '综合',
              },
              {
                id: 11,
                name: '播放最多',
                shotName: '播放最多',
              },
              {
                id: 10,
                name: '最近更新',
                shotName: '最近更新',
              },
            ],
          });
          return category;
        }

        if (pro.productType === '一企学') {
          category.unshift({
            name: '排序',
            list: [
              {
                id: 1,
                name: '综合',
                shotName: '综合',
              },
              {
                id: 2,
                name: '畅销',
                shotName: '畅销',
              },
              {
                id: 6,
                name: '好评优先',
                shotName: '好评优先',
              },
            ],
          });
          return category;
        }

        if (pro.productType === '运动健身') {
          return category.push({
            name: '价格',
            sort: true,
            list: [
              {
                id: 0,
                name: 'asc',
              },
              {
                id: 1,
                name: 'desc',
              },
            ],
          });
        }
        if (pro.productType === '演出') {
          return category.push(
            {
              name: '时间',
              list: [
                {
                  id: 0,
                  name: TLang('一周内', 'result'),
                  num: 7,
                },
                {
                  id: 1,
                  name: TLang('一个月内', 'result'),
                  num: 30,
                },
                {
                  id: 2,
                  name: TLang('三个月内', 'result'),
                  num: 90,
                },
              ],
            },
            {
              name: '票价',
              sort: true,
              list: [
                {
                  id: 0,
                  name: 'asc',
                },
                {
                  id: 1,
                  name: 'desc',
                },
              ],
            },
          );
        }

        // 体检套餐、口腔健康、健康服务添加综合排序/价格
        if (['口腔健康', '健康服务', '体检套餐'].includes(pro.productType)) {
          category.unshift({
            name: '排序',
            list: [
              {
                id: 1,
                name: '综合排序',
                shotName: '综合',
              },
              {
                id: 5,
                name: '热度优先',
                shotName: '热度',
              },
            ],
          });
          category.push({
            name: '价格',
            sort: true,
            list: [
              {
                id: 0,
                name: 'asc',
              },
              {
                id: 1,
                name: 'desc',
              },
            ],
          });
          return category;
        }

        // 美团酒店
        if (pro.productType === '酒店') {
          // category = [];
          hotelFilter(category);
          return category;
        }

        // 亲子活动，亲子酒店，玩乐门票
        if (pro.productType === '亲子活动' || pro.productType === '亲子酒店' || pro.productType === '玩乐门票') {
          // category = [];
          lexiangFilter(category);
          return category;
        }
         if (pro.productType === '玩乐') {
          const start = category.findIndex((item) => item.name === '分类');
          start > -1 && category.splice(start, 1);
          const end = category.findIndex((item) => item.name === '目的地');
          end > -1 && category.splice(end, 1);
        }
      }
    });
  }
  if (category && category.length) {
    arr = category.map((cate) => {
      return cate.name === '城市'
        ? {
            ...cate,
            multiSelect: true,
          }
        : cate;
    });
  }
  return arr;
}

function getSearchTags(ids, searches, productTypes, commit, state, onlyGetOrg, totalCount, isGuide, busTagParams, pageIndex, name, totalNumber, categorys) {
  getTags(ids).then((res) => {
    if (res && res.data && res.data.body) {
      res.data.body.map((item) => {
        let good = {
          goodsId: item.goodsId,
          categoryId: item.categoryId,
        };
        good = dealTagsList(res.data.body, good, null, false, false, productTypes == '体检套餐' || productTypes == '健康商城');

        // 增加体检套餐营销标签的判断
        const index = searches.findIndex((t) => t.id === item.goodsId && (t.categoryId === item.categoryId || (t.productType == '体检套餐' && item.categoryId === 0)));

        if (index > -1) {
          searches[index].tags = item && item;
          searches[index].promoStickerInfo = good.promoStickerInfo || [];
          searches[index].hasPromoSticker = good.hasPromoSticker;
          searches[index].hasPromoTags = good.hasPromoTags;
          searches[index].promoTags = good.promoTags || [];

          searches[index].bizStock = item.bizStock;
          // 折上折
          searches[index].mktTagShow = good.mktTagShow;
          searches[index].discountTagShow = good.discountTagShow;
          searches[index].discountPrice = good.discountPrice;
          searches[index].discount = good.discount;
          searches[index].totalLimit = good.totalLimit;
          searches[index].saleNum = good.saleNum || 0;
          searches[index].dfPriceVo = good.dfPriceVo || null;
        }
      });
    }
    // searches.forEach(good => {
    //   // if (good.hasOwnProperty('isNewShowPrice')) {
    //   //   good.isShowPrice = good.isNewShowPrice
    //   // }
    // })
    changeStoreData(commit, state, onlyGetOrg, searches, totalCount, isGuide, busTagParams, pageIndex, name, totalNumber, categorys, true);
  });
}

function getKeyMapOfList(list) {
  const dataList = {};

  if (Array.isArray(list)) {
    list.forEach((item) => {
      const key = `${item.categoryId}-${item.id}`;
      dataList[key] = item;
    });
  }

  return dataList;
}

function merageNameOfSame(allList, list, isTagSource) {
  if (allList.length === 0) {
    return list;
  }
  if (!isTagSource) {
    return [...allList, ...list];
  }
  const keyMap = getKeyMapOfList(list);
  const keyMap2 = { ...keyMap };

  const merageList = allList.map((item) => {
    const isAllKey = `${item.categoryId}-${item.id}`;
    if (keyMap[isAllKey]) {
      delete keyMap2[isAllKey];
      return keyMap[isAllKey];
    }
    return item;
  });

  return merageList.concat(Object.values(keyMap2));
}

// 更新缓存
function changeStoreData(commit, state, onlyGetOrg, searches, totalCount, isGuide, busTagParams, pageIndex, name, totalNumber, categorys, isTag) { 
  if (onlyGetOrg) {
    if (state.home.searches.length > 0) {
      commit('updateData', {
        topOrgList: searches ? searches.slice(0, 3) : [],
        orgTotal: totalCount,
        isAllOrgData: false,
        value: true,
        name,
        onlyGetOrg,
        recommendList: [],
        isGuide: isGuide,
        ...busTagParams,
      });
    } else {
      commit('updateData', {
        // category: categorys ? categorys : [],
        searches: searches ? searches : [],
        name,
        pageIndex,
        totalNumber,
        value: true,
        totalCount,
        isAllOrgData: true,
        onlyGetOrg,
        recommendList: [],
        isGuide: isGuide,
        ...busTagParams,
      });
    }
  } else {
    commit('updateData', {
      // category: categorys ? categorys : [],
      searches: searches ? searches : [],
      ...busTagParams,
      name,
      pageIndex,
      totalNumber,
      value: true,
      totalCount,
      recommendList: [],
      isGuide: isGuide,
    });
  }
  if (pageIndex === 1) {
    window.sessionStorage.setItem('searchData', '');
  }

  const _searchData = window.sessionStorage.getItem('searchData');
  if (_searchData) {
    const _cacheData = JSON.parse(_searchData);
    if (_cacheData.pageIndex !== pageIndex || isTag) {
      if (searches) {
        _cacheData.searches = merageNameOfSame(_cacheData.searches, searches, isTag);
        // [..._cacheData.searches, ...searches]
      }
      if (categorys) {
        _cacheData.category = [...categorys];
      }

      const d = {
        ..._cacheData,
        ...busTagParams,
        name,
        pageIndex,
        totalNumber,
        value: true,
        totalCount,
        recommendList: [],
        isGuide: isGuide,
        allRecommenGoodsResult: state['allRecommenGoodsResult']
      };
      window.sessionStorage.setItem('searchData', JSON.stringify(d));
    }
  } else {
    window.sessionStorage.setItem(
      'searchData',
      JSON.stringify({
        // category: categorys ? categorys : [],
        searches: searches ? searches : [],
        ...busTagParams,
        name,
        pageIndex,
        totalNumber,
        value: true,
        totalCount,
        recommendList: [],
        isGuide: isGuide,
      }),
    );
  }
}

/**
 * 获取address信息
 * @param {String} key
 * return
 */
export function getCookieAddressInfo(key) {
  const addr = JSON.parse(getCatchAddress() || null);
  if (addr) {
    if (key) {
      return addr[key];
    } else {
      return addr;
    }
  }
  return null;
}

// 获取频道内搜索id对应productTypes
export function getChannelText(id) {
  if (id) {
    switch (Number(id)) {
      case 14:
        return ['超值馈'];
        break;
      case 2:
        return ['优选生活'];
        break;
      default:
        return [];
        break;
    }
  }
}

// 获取频道内搜索id对应router
export function getChannelRouter(id) {
  if (id) {
    switch (Number(id)) {
      case 14:
        return 'feedBack';
        break;
      case 2:
        return 'life';
        break;
      default:
        return 'home';
        break;
    }
  }
}

/**
 * 是否是统一商城 true代表是
 */
 export function checkUnifyShop() {
  const _win = window
  if (_win.dfWebUnifyShop === true) {
    return true
  } else {
    return false
  }
}

// 防抖
export function debounceFn(fn, ms = 0) {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
};

// 节流
export function throttleFn(fn, delay = 200) {
  let timer = null
  return function () {
    if (timer) return
    timer = setTimeout(() => {
      fn.apply(this, arguments)
      timer = null
    }, delay)
  }
}

// 是否显示购物车
export function showShoppingCart(path) {
  // return path === 'life' || path === 'cake' || path === 'book' || path === 'jdyx' || path === 'xmyp' || path === 'wyyx' || constant.newEntityPath.includes(path) || path === 'chaoshi' || path === 'sxChange' || path === 'offline';
  // 除了节日礼包，都显示购物车
  return path !== 'spree'
}

// 隐藏用户定位城市  亲子活动、亲子酒店、玩乐门票、景点、玩乐，当用户切换到上述5个搜索Tab时，隐藏用户定位城市
export function hideUserCity(path) {
  return ['lxHotel', 'lxActivity', 'lxScenery', 'scenery', 'tour'].includes(path)
}

// 是否全部页签
export function getPath() {
  const path = location.pathname.replace("/ms", "");
  const name = path.substring(1)
  return name
}

/* 判断是否是游客或体验码用户 */
export function checkIsTourist(code) {
  return [1000000, 1000001, 'AUTH001003', 'AUTH001004'].includes(String(code))
}
